module.exports = __webpack_public_path__ + "static/media/ic_send_canvas.17c8228f.svg";